export default __webpack_public_path__ + "static/media/users.b203b926.svg";